/* eslint-disable import/prefer-default-export */
import { ref } from "vue";
import { defineStore } from "pinia";

import useLocalStorage from "@/composables/storage/useLocalStorage.js";
import filters from "@/composables/store/filters";
import useFormValidation from "@/composables/validations/useFormValidation";

const { checkLocalStorage, bindLocalStorage } = useLocalStorage();
const { formHasErrors, getErrorByField } = filters();
const { validateCheckboxField } = useFormValidation();

const formObject = ref({
  country: {
    value: null,
    required: true,
  },
  citizenshipCountries: {
    value: [],
    required: false,
  },
  employmentStatus: {
    value: null,
    required: false,
  },
  jobTitle: {
    value: null,
    required: false,
  },
  organization: {
    value: null,
    required: false,
  },
  industryType: {
    value: null,
    required: true,
  },
  yearlyAmount: {
    value: null,
    required: true,
  },
  potMainPurpose: {
    value: null,
    required: true,
  },
  originOfFunds: {
    value: [],
    required: true,
  },
  tnc: {
    value: null,
    error: null,
    required: true,
    validator: validateCheckboxField,
  },
});

export const usePepSourceOfFundsFormStore = defineStore({
  id: "usePepSourceOfFundsFormStore",
  state: () => ({
    form: formObject,
  }),
  getters: {
    formHasErrors: (store) => formHasErrors(store),
    getErrorByField: (store) => (field) => getErrorByField(store)(field),
  },
  actions: {
    updateValue(field, val) {
      if (!Object.getOwnPropertyDescriptor(this.form, field)) {
        return;
      }

      if (Object.getOwnPropertyDescriptor(this.form[field], "validator")) {
        const { validator } = this.form[field];
        this.form[field].error = validator(field, val);
      }
      this.form[field].value = val;
      bindLocalStorage(this.$id, this.form);
    },
  },
});
